namespace GeniuzPOS.InitialData {
    export enum PsPosStationEumConnectVFDFg {
        ConnectVFDFgNo = 0,
        ConnectVFDFgYes = 1
    }
    Serenity.Decorators.registerEnumType(PsPosStationEumConnectVFDFg, 'GeniuzPOS.InitialData.PsPosStationEumConnectVFDFg');
}
